<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Utenti', route: '/backoffice/utenti' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Elenco utenti</h2>
    </div>

    <p-table #dt
        [loading]="loading"
        [value]="utenti"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [rowHover]="true"
        [globalFilterFields]="['username','email']"
        currentPageReportTemplate="{first} di {last} su {totalRecords} utenti"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20, 50]">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full items-stretch">
                <input type="text" pInputText class="flex-1" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca utente…" />
                <div class="table-toolbar-btns">
                    <a class="acc-btn acc-btn-primary" routerLink="/backoffice/utenti/add">
                        <i class="bi bi-plus"></i>
                        Aggiungi utente
                    </a>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="username">Username <span class="inline-flex"><p-sortIcon field="username" /></span></th>
                <th pSortableColumn="email">Email <span class="inline-flex"><p-sortIcon field="email" /></span></th>
                <th pSortableColumn="tipo">Ruolo <span class="inline-flex"><p-sortIcon field="tipo" /></span></th>
                <th class="text-center" style="width:6rem">2FA</th>
                <th class="text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-utente>
            <tr>
                <td>
                    <span class="p-column-title">Username</span>
                    <span class="cell-nome">{{utente.username}}</span>
                </td>
                <td>
                    <span class="p-column-title">Email</span>
                    {{utente.email || '-'}}
                </td>
                <td>
                    <span class="p-column-title">Ruolo</span>
                    {{utente.tipo}}
                </td>
                <td class="text-center">
                    <span class="p-column-title">2FA</span>
                    <span class="scheda-stato-pill ok" *ngIf="isTotpOn(utente)" style="display:inline-flex">Attiva</span>
                    <span *ngIf="!isTotpOn(utente)" style="color: var(--acc-ink-mute)">—</span>
                </td>
                <td class="text-center">
                    <span class="p-column-title">Azioni</span>
                    <div class="table-actions">
                        <i class="bi bi-shield-lock" (click)="openTotp(utente)" pTooltip="Gestisci 2FA" tooltipPosition="bottom"></i>
                        <p-divider layout="vertical"></p-divider>
                        <i class="bi bi-pencil" [routerLink]="'/backoffice/utenti/' + utente.id" pTooltip="Modifica" tooltipPosition="bottom"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteUtente>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeleteUtente()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteUtente()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeleteUtente($event, utente)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">Nessun utente trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>

<p-dialog
    [visible]="totpDialog"
    [style]="{width: 'min(28rem, 94vw)'}"
    [header]="'2FA — ' + (totpUtente?.username || '')"
    [modal]="true"
    [focusOnShow]="false"
    styleClass="accrediti-dialog"
    (visibleChange)="closeTotp()">
    <ng-template pTemplate="content">
        <ng-container *ngIf="totpUtente && !isTotpOn(totpUtente) && !totpSetup">
            <div class="accrediti-form flex flex-col gap-4">
                <p class="text-sm m-0" style="color: var(--acc-ink-mute)">Attiva l’autenticazione a due fattori per questo utente. Verrà generato un QR da scansionare con l’app autenticatore.</p>
                <div class="acc-actions">
                    <button type="button" class="acc-btn acc-btn-ghost" (click)="closeTotp()">Annulla</button>
                    <button type="button" class="acc-btn acc-btn-primary" (click)="startTotpSetup()">Genera QR</button>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="totpUtente && !isTotpOn(totpUtente) && totpSetup">
            <div class="accrediti-form flex flex-col gap-4">
                <p class="text-sm m-0" style="color: var(--acc-ink-mute)">Scansiona il QR oppure inserisci il codice manuale, poi conferma con il codice OTP:</p>
                <img *ngIf="totpSetup.qr" [src]="totpSetup.qr" alt="QR 2FA" class="mx-auto border" width="220" height="220" />
                <code class="text-xs break-all p-2 block" style="background: var(--acc-bg-soft); border: 1px solid var(--acc-line); border-radius: var(--acc-radius)">{{ totpSetup.secret }}</code>
                <form [formGroup]="formTotpEnable" (ngSubmit)="confirmTotpEnable()" class="flex flex-col gap-4">
                    <div class="fld">
                        <label>* Codice di verifica</label>
                        <input type="text" pInputText class="w-full" formControlName="code" maxlength="6" inputmode="numeric" autocomplete="one-time-code" placeholder="000000" />
                    </div>
                    <div class="acc-actions">
                        <button type="button" class="acc-btn acc-btn-ghost" (click)="closeTotp()">Annulla</button>
                        <button type="submit" class="acc-btn acc-btn-primary" [disabled]="!formTotpEnable.valid">Conferma e attiva</button>
                    </div>
                </form>
            </div>
        </ng-container>

        <ng-container *ngIf="totpUtente && isTotpOn(totpUtente)">
            <div class="accrediti-form flex flex-col gap-4">
                <p class="text-sm m-0" style="color: var(--acc-ink-mute)">2FA attiva su questo account. Puoi disattivarla (reset amministratore, senza OTP).</p>
                <div class="acc-actions">
                    <button type="button" class="acc-btn acc-btn-ghost" (click)="closeTotp()">Chiudi</button>
                    <button type="button" class="acc-btn acc-btn-danger" (click)="confirmTotpDisable()">Disattiva 2FA</button>
                </div>
            </div>
        </ng-container>
    </ng-template>
</p-dialog>
